export default __webpack_public_path__ + "static/media/1967.efa2c3f9.png";